import { graphql } from 'gatsby';
import React from 'react';

import { Box, Container, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  useContentfulInspectorMode, useContentfulLiveUpdates
} from '../shared/hooks/contentful';

import { ButtonList, ContentfulAssetImage, HomepageLink } from './ui';

export type CtaProps = Queries.HomepageCtaContentFragment;

export default function HomepageCta(props: CtaProps) {
  const theme = useTheme()
  const inspectorProps = useContentfulInspectorMode();

  const { image, disableBackground, heading, text, links }: CtaProps = useContentfulLiveUpdates({
    ...props,
    sys: { id: props.contentful_id },
  });

  // const theImage = getImage(image);
  // const theImage = useMemo(() => {
  //   return disableBackground ? image.localFile.childImageSharp.largeImage : image.localFile.childImageSharp.standardImage
  // }, [disableBackground])

  return (
    <Container sx={{ mt: 6 }}>
      <Box
        borderRadius={theme.shape.borderRadius * 0.3}
        sx={{
          p: { xs: 3, sm: 4, md: 5 },
          background: disableBackground ? undefined : `linear-gradient(180deg, #1E1F21 20%, #262A61 200%)`,
        }}
      >
        <Stack direction="row" gap={2}
          justifyContent={"space-around"}
          alignItems={"center"}>
          <Stack
            direction="column"
            justifyContent={"space-between"}
            alignItems={"center"}
            gap={{ xs: 12, sm: 12, md: 2, lg: 2 }}
          >
            <Stack direction="column" gap={{ xs: 3, sm: 4, md: 6, lg: 6 }}>
              <Typography variant="h1" sx={{ color: disableBackground ? undefined : theme.palette.common.white }} {...inspectorProps({
                entryId: props.contentful_id,
                fieldId: 'heading',
              })}>
                {heading}
              </Typography>
              {text && (
                <Typography
                  variant="body1"
                  sx={{ color: disableBackground ? undefined : theme.palette.common.white, whiteSpace: "pre-wrap" }}
                  {...inspectorProps({
                    entryId: props.contentful_id,
                    fieldId: 'text',
                  })}
                >
                  {text}
                </Typography>)}
              <ButtonList links={links as any as HomepageLink[]} />
            </Stack>
          </Stack>

          <Box sx={{ display: { xs: "none", sm: "none", md: "inherit" } }}>
            {/* <ContentfulAssetImage
              asset={data.image}
              loading='lazy'
              contentfulPreviewProps={inspectorProps({
                entryId: props.contentful_id,
                fieldId: 'image',
              })}
            /> */}

            <ContentfulAssetImage
              // height={theImage.height}
              // width={theImage.width}
              contentfulPreviewProps={inspectorProps({
                entryId: props.contentful_id,
                fieldId: 'image',
              })}
              loading={disableBackground ? "eager" : "lazy"}
              asset={image}
            />
          </Box>
        </Stack>
      </Box>
    </Container>
  )
}

export const query = graphql`
  fragment HomepageCtaContent on ContentfulHomepageCta {
    id
    heading
    text
    __typename
    contentful_id
    disableBackground
    image {
      url
      title
      id
      contentful_id
      __typename
      localFile {
        childImageSharp {  
          # standardImage: gatsbyImageData(
          #   placeholder: NONE
          #   breakpoints: [140, 200]
          #   quality: 100
          #   width: 120
          #   layout: CONSTRAINED
          # )
          # largeImage: gatsbyImageData(
          #   placeholder: NONE
          #   breakpoints: [340, 400]
          #   quality: 100
          #   width: 400
          #   layout: CONSTRAINED
          # )
           gatsbyImageData(
            placeholder: NONE
            breakpoints: [300, 400]
            quality: 100
            height: 400
          )
        }
      }
    }
    links {
      id
      href
      text
      __typename
      contentful_id
    }
  }
`
